import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, OtherWorkEvent, OtherWorkEventWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateOtherWorkEvent(): UseMutationResult<
  AxiosResponse<OtherWorkEvent>,
  AxiosError<ErrorMessage>,
  OtherWorkEventWrite
> {
  const queryClient = useQueryClient();

  const createOtherWorkEvent = useCallback(
    (otherWorkEvent: OtherWorkEventWrite): Promise<AxiosResponse<OtherWorkEvent>> => {
      return client.post('other-work-events/', otherWorkEvent);
    },
    [],
  );
  return useMutation(createOtherWorkEvent, {
    onSuccess: () => {
      queryClient.invalidateQueries('otherWorkEvents');
    },
  });
}
